import React, { useContext } from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import { useVisible } from '../../hooks/useVisible/useVisible.es.js';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import { Group } from '../../primitives/Group/Group.es.js';
import { Drawer } from '../Drawer/Drawer.es.js';
import Button from '../Button/Button.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
import { defaultStaticText, FiltersInternalContext } from './api.es.js';
import { StyledFilters, FiltersIcon, StyledDrawerFooter } from './styled/Filters.es.js';
import './styled/Filter.es.js';
import './styled/ListFilter.es.js';
import './styled/SelectedFilters.es.js';
import { Filter } from './Filter.es.js';

var Filters = function Filters(_ref) {
  var children = _ref.children,
      onClearAll = _ref.onClearAll,
      _ref$staticText = _ref.staticText,
      staticText = _ref$staticText === void 0 ? defaultStaticText : _ref$staticText,
      _ref$ariaLabelForIcon = _ref.ariaLabelForIconButton,
      ariaLabelForIconButton = _ref$ariaLabelForIcon === void 0 ? "filter-button" : _ref$ariaLabelForIcon,
      _ref$isClearAllVisibl = _ref.isClearAllVisible,
      isClearAllVisible = _ref$isClearAllVisibl === void 0 ? true : _ref$isClearAllVisibl;
  var isMobile = useBreakpoint("md");
  return (
    /* @__PURE__ */
    React.createElement(Group, {
      direction: "vertical",
      gutter: "xxs"
    },
    /* @__PURE__ */
    React.createElement(FiltersInternalContext.Provider, {
      value: {
        staticText: staticText
      }
    }, isMobile ?
    /* @__PURE__ */
    React.createElement(Group.Item, null,
    /* @__PURE__ */
    React.createElement(MobileFiltersList, {
      onClearAll: onClearAll,
      ariaLabel: ariaLabelForIconButton,
      isClearAllVisible: isClearAllVisible
    }, children)) :
    /* @__PURE__ */
    React.createElement(Group.Item, null,
    /* @__PURE__ */
    React.createElement(StyledFilters, {
      direction: "horizontal",
      gutter: "sm"
    },
    /* @__PURE__ */
    React.createElement(Group.Item, null,
    /* @__PURE__ */
    React.createElement(FiltersIcon, {
      size: "base",
      title: "Filters"
    })), children))))
  );
};

Filters.Filter = Filter;

var MobileFiltersList = function MobileFiltersList(_ref2) {
  var children = _ref2.children,
      onClearAll = _ref2.onClearAll,
      ariaLabel = _ref2.ariaLabel,
      isClearAllVisible = _ref2.isClearAllVisible;

  var _useVisible = useVisible(false),
      visible = _useVisible.visible,
      show = _useVisible.show,
      hide = _useVisible.hide;

  var _useContext = useContext(FiltersInternalContext),
      staticText = _useContext.staticText;

  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null,
    /* @__PURE__ */
    React.createElement(Button, {
      "aria-label": ariaLabel,
      onClick: show,
      icon: FiltersIcon,
      isRounded: !!staticText.filters,
      variant: "ghost",
      mb: staticText.filters ? "md" : 0
    }, staticText.filters),
    /* @__PURE__ */
    React.createElement(Drawer, {
      side: "bottom",
      isVisible: visible,
      onClose: hide
    },
    /* @__PURE__ */
    React.createElement(Drawer.Content, {
      px: "lg",
      py: "xs"
    }, children),
    /* @__PURE__ */
    React.createElement(StyledDrawerFooter, {
      px: "lg",
      py: "sm"
    },
    /* @__PURE__ */
    React.createElement(Box, null, isClearAllVisible &&
    /* @__PURE__ */
    React.createElement(Button, {
      variant: "secondary",
      size: "sm",
      kind: "minimal",
      onClick: onClearAll
    }, staticText.clearFilters)),
    /* @__PURE__ */
    React.createElement(Button, {
      variant: "primary",
      size: "sm",
      kind: "minimal",
      onClick: hide
    }, staticText.close))))
  );
};

export { Filters };